const Strings = {
  SIGN_OUT: 'Logga ut',
  USERS: 'Användare',
  LAUNDRY_SETTINGS: 'Tvättinställningar',
  INFORMATION_SETTINGS: 'Infotavlan',
  NEWS: 'Nyhetsflöde',
  LAUNDRY_BOOKINGS: 'Tvättbokningshistorik',
  BOOKABLE_OBJECTS: 'Bokningssystem',
  BOOKING_SYSTEM_HISTORY: 'Bokningshistorik',
  SETTINGS: 'Inställningar'
}

export default Strings



// WEBPACK FOOTER //
// ./src/components/common/ListItems/strings.js